export interface IReplayConfig {
    name: string,
    replayConfigUUID?: string,
    sinkType: string,
    sinkParams: {
        location: string, 
        secretPath: string,
        paths: IPath[],
        mappings: IMapping[],
    },
    timingOption: string,
    status?: string,
}

interface IPath {
    url: string
}

interface IMapping {
    from: string,
    to: string,
}

export interface IGetReplayConfigsResponse {
    data: IReplayConfig[],
}

export interface IPostReplayConfigResponse {
    data: IReplayConfigUUIDResponse,
}

export interface IPutReplayConfigResponse {
    data: IReplayConfigUUIDResponse,
}

export interface IReplayConfigUUIDResponse {
    replayConfigUUID: string,
}

export const DefaultReplayConfig: IReplayConfig = {
    name: "",
    sinkType: "mqtt",
    sinkParams: {
        location: "",
        secretPath: "",
        paths: [],
        mappings: [{from: "#", to: "#"}],
    },
    timingOption: "actual",
}